import { Typography } from "@mui/material";
import React from "react";

function NotFound() {
  return (
    <div
      style={{
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40vh",
        color:'gray'
      }}
    >
      <Typography variant="h5">404 - Not Found </Typography>
    </div>
  );
}

export default NotFound;
